import apiClient from '../api/apiClient'; // ✅ جایگزین axiosPublicInstance

// تولید شناسه مهمان (همان uuid ساده)
const generateGuestId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

// دریافت یا ساخت شناسه مهمان
const getGuestId = () => {
    let guestId = localStorage.getItem('ai_guest_id');
    if (!guestId) {
        guestId = generateGuestId();
        localStorage.setItem('ai_guest_id', guestId);
    }
    return guestId;
};

// ارسال پیام چت (بدون نیاز به مدیریت دستی توکن)
export const sendChatQuery = async (query) => {
    const guestId = getGuestId();

    try {
        // ✅ apiClient به صورت خودکار توکن را الصاق می‌کند (در صورت بودن)
        // و baseURL آن به /api/v1 ختم می‌شود، بنابراین مسیر نسبی /ai/chat/ کافی است
        const response = await apiClient.post('/ai/chat/', 
            { query }, 
            {
                headers: {
                    'X-Guest-ID': guestId,
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("AI Chat Error:", error);
        throw error;
    }
};